<template>
  <section>
    <div class="banner half-vh">
      <img class="banner-image" src="./../assets/images/large/photo-store-locator.jpg" alt=""
        v-bind:srcset="photos.xs + ' 320w, ' + photos.s + ' 768w, ' + photos.m + ' 1440w, ' + photos.l + ' 1920w'"
      >
    </div>
    <div class="container" id="store-locator">
      <div class="text-content-wrapper">
        <h1>Store Locator</h1>
        <button class="btn btn-primary btn-lg find-closest" type="button" v-on:click="findClosestStore">
          Find Closest Store <icon name="chevron-right" class="chevron-right-icon"></icon>
        </button>
        <div class="form-group search-form-group">
          <icon name="search" class="search-icon"></icon>
          <input type="text" class="form-control" id="search" v-model="storeFilter" name="search" placeholder="Search">
        </div>
        <ul class="stores">
          <li v-for="(marker, index) in filteredStores" v-on:click="showStore(marker)">
            {{marker.name}}
          </li>
        </ul>
      </div>
    </div>

    <div class="google-maps-wrapper" v-bind:class="{ active: map.active }">
      <button class="close" type="button" name="button" v-on:click="map.active = false;">
        <icon name="times" class="times-icon"></icon>
      </button>
      <gmap-map
        v-on:click="goToStore(currentMarker)"
        :center="map.center"
        :zoom="16"
        :options="map.options"
      >
        <gmap-marker
          :key="index"
          v-for="(marker, index) in map.markers"
          :position="marker.coordinates"
          :clickable="true"
          :draggable="false"
          @click="map.center=marker.coordinates"
        ></gmap-marker>
      </gmap-map>

      <div class="info" v-if="currentMarker">
        <div class="container">
          <div class="text-content-wrapper">
            <h5>{{currentMarker.name}}</h5>

            <div class="row">
              <div class="col-2">
                <icon name="map-marker" class="map-marker-icon"></icon>
              </div>
              <div class="col-10">
                <h6>Address</h6>
                <p>
                  <span v-for="(line, lineNumber) in currentMarker.address.split(',')" v-bind:index="lineNumber">
                    {{line}}<span class="comma" v-if="lineNumber < currentMarker.address.split(',').length-1">,</span><br/>
                  </span>
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <icon name="phone" class="phone-icon"></icon>
              </div>
              <div class="col-10">
                <h6>Telephone</h6>
                <p>
                  <span v-for="(number, numberIndex) in currentMarker.phone.split(' / ')" v-bind:index="numberIndex">
                    {{number}} <span class="pipe" v-if="numberIndex < currentMarker.phone.split(' / ').length-1">/</span>
                  </span><br/>
                  {{currentMarker.fax}} <span v-if="currentMarker.fax">(fax)</span>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours';
  @import '../scss/mixins';

  section{
    position: relative;

    @include breakpoint(lg){
      padding: 0;
    }
  }

  .banner{
    margin-bottom: 0;
  }

  @include breakpoint(lg){

    .banner-image{
      margin-top: -7%;
    }

    .page > section .text-content-wrapper{
      padding: 2em;
    }
  }

  .find-closest{
    cursor: pointer;
    width: 100%;
    background-color: $blue;
    border: none;

    .chevron-right-icon{
      height: 20px;
      width: auto;
      margin-left: 5px;
      margin-bottom: -3px;
    }

    &:hover{
      background-color: lighten($blue, 5%);
    }

    &:active{
      background-color: $blue-dark;
    }
  }

  .search-form-group{
    margin: 1em 0;
    position: relative;
  }

  .search-icon{
    position: absolute;
    right: 0;
    top: 10px;
  }

  input{
    padding: 10px 0 5px 0;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid $red;
  }

  ul.stores{
    list-style: none;
    padding: 0;
    margin: 0;
    display: block;
    border-radius: 4px;
    height: 400px;
    height: 33.5vh;
    overflow-y: scroll;
    font-family: Helvetica, Arial, sans-serif;

    @include breakpoint(lg){
      position: absolute;
      top: 220px;
      bottom: 2em;
      left: 2em;
      right: 2em;
      height: auto;
    }

    li{
      cursor: pointer;
      display: block;
      padding: 10px 10px;
      color: white;
      background: $red;
      margin-bottom: 1px;

      &:hover{
        background: lighten($red, 5%);
      }

      &:active{
        background: $red-dark;
      }

      &:first-child{
        border-radius: 4px 4px 0 0;
      }

      &:last-child{
        border-radius: 0 0 4px 4px;
      }
    }
  }

  section > .container{
    @include breakpoint(lg){
      z-index: 76;
      position: relative;
      width: 350px;
      min-height: 450px;
      height: 50vh;
      float: left;
      background-color: white;
      padding: 0;
      margin: 0;
    }
  }

  .google-maps-wrapper{
    //display: none;
    z-index: 75;
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease-in-out;

    @include breakpoint(lg){
      pointer-events: auto;
      opacity: 1;
      position: relative;
      top: auto;
      right: auto;
      bottom: auto;
      padding-left: 700px;
      width: 100%;
      min-height: 450px;
      height: 50vh;
    }

    &.active{
      //display: block;
      pointer-events: auto;
      opacity: 1;
    }

    button.close{
      position: absolute;
      z-index:100;
      top: 10px;
      right: 10px;
      width: 40px;
      height: 40px;
      background-color: none;
      color: $red;
      opacity: 1;
      padding: 0;

      @include breakpoint(lg){
        display: none;
      }

      .times-icon{
        width: auto;
        height: 1.5em;
      }
    }

    .vue-map-container{
      width: 100%;
      height: 40%;
      top: 0;

      @include breakpoint(lg){
        height: 100%;
      }
    }

    .info{
      background-color: $yellow;
      bottom: 0;
      width: 100%;
      height: 60%;
      padding-top: 1em;

      @include breakpoint(lg){
        position: absolute;
        background-color: darken(white, 5%);
        top: 0px;
        right: auto;
        bottom: 0px;
        left: 350px;
        width: 350px;
        height: auto;

        .text-content-wrapper{
          padding-top: 80px;
          //padding-left: 0;
        }
      }

      .fa-icon{
        width: auto;
        height: 2em;
        color: $red;
      }

      .pipe{
        color: $grey-medium;
      }

      p{
        font-size: 0.9em;
      }

      h5{
        margin-bottom: 1em;
      }

      h6{
        margin-bottom: 0;
      }
    }
  }
</style>

<script>

import { createClient } from "contentful";

const client = createClient({
  space: "r4kjztul5agf",
  accessToken: "woQwhNRxg--st0klHyPAvNk5tQF6q0HpjB1TqSk2EtE"
});

import Vue from 'vue'
import Utils from '@/mixins/Utils'
import _ from 'lodash'

var photos = {
  xs: require('./../assets/images/x-small/photo-store-locator_xs.jpg'),
  s: require('./../assets/images/small/photo-store-locator_s.jpg'),
  m: require('./../assets/images/medium/photo-store-locator_m.jpg'),
  l: require('./../assets/images/large/photo-store-locator.jpg')
}

export default {
  name: 'store-locator',
  mixins: [Utils],
  created: function () {
    client.getEntries({
      content_type: "store"
    }).then(function(response) {
      this.$data.map.markers = response.items.filter(store => !!store.fields.location).map(store => {
        const id = store.sys.id;
        const { displayName, address, phone, location } = store.fields;

        return {
          id,
          name: displayName,
          address,
          phone,
          coordinates: { lat: location.lat, lng: location.lon }
        }
      });
      
      var lastIndex = this.map.markers.length - 1
      this.$data.currentMarker = this.map.markers[lastIndex]
      this.$data.map.center = this.map.markers[lastIndex].coordinates
    }.bind(this));

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      }.bind(this))
    }
  },
  computed: {
    photos () { return photos },
    mapCenter: function () {
      return this.$data.map.center
    },
    filteredStores: function () {
      if (!this.$data) {
        return this.$data.map.markers
      }

      var storeFilter = this.$data.storeFilter.toLowerCase()

      var ordered = _.orderBy(this.$data.map.markers, ['name'], ['asc'])

      if (!storeFilter || storeFilter === '') {
        return ordered
      }

      var filtered = _.filter(ordered, function (marker) {
        // return true
        var name = marker.name.toLowerCase()
        var address = marker.address.toLowerCase()
        return name.toLowerCase().indexOf(storeFilter) >= 0 || address.indexOf(storeFilter) >= 0
      })
      return filtered
    }
  },
  watch: {
    // whenever question changes, this function will run
    mapCenter: function (newCenter) {
    }
  },
  methods: {
    findClosestStore: function () {
      if (!this.currentLocation) {
        return
      }

      client.getEntries({
        content_type: "store",
        "fields.location[near]": this.currentLocation.lat + "," + this.currentLocation.lng,
        "limit": 1
      }).then(function(response) {
        if (response.items.length > 0) {
          const nearestStore = response.items[0];
          const id = nearestStore.sys.id;

          const store = this.$data.map.markers.filter(item => item.id === id);

          if (store.length > 0) {
            this.showStore(store[0]);
          }
        }
      }.bind(this));
    },
    showStore: function (marker) {
      window.gtag('event', 'click', {
        'event_category': 'store locator',
        'event_label': 'store'
      })
      this.$data.currentMarker = marker
      this.$data.map.center = marker.coordinates
      this.$data.map.active = true
    },
    goToStore: function (marker) {
      if (!marker) {
        return
      }

      window.open('http://maps.google.com/?q=' + marker.coordinates.lat + ',' + marker.coordinates.lng, '_blank')
    }
  },
  data () {
    return {
      currentMarker: null,
      storeFilter: '',
      map: {
        active: false,
        options: {
          streetViewControl: false,
          mapTypeControl: false,
          draggable: false,
          zoomControl: false,
          scrollwheel: false,
          fullscreenControl: false,
          disableDoubleClickZoom: true
        },
        center: {lat: -29.83580, lng: 30.910775},
        markers: []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StoreLocator.vue